"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENCRYPTED_BY = void 0;
var ENCRYPTED_BY;
(function (ENCRYPTED_BY) {
    ENCRYPTED_BY["PASSPHRASE"] = "passphrase";
    ENCRYPTED_BY["RECOVERY_KEY"] = "recovery_key";
})(ENCRYPTED_BY || (exports.ENCRYPTED_BY = ENCRYPTED_BY = {}));
